import React from 'react';
import { formatBoolean } from '../../../../../Helpers/Table/ProductPropertyHelper';

interface Props {
    value: string;
}

export const Boolean: React.FC<Props> = ({ value }: Props) => (
    <>{formatBoolean(value)}</>
);
